import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { addFaq, editFaq, getSingleFaq } from "../../redux/services/faqSlice";
import { ROUTES } from "../../constant";

const FaqType = ["course", "workshop", "landing-page"];

const FAQForm = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const singleFaq = useSelector((state) => state.faq.singleFaqData);
  const queryParams = new URLSearchParams(location.search);
  const faqId = queryParams.get("faqId");
  const [loading, setLoading] = useState(false);

  const pathname = location?.pathname.split("/")[1]

  const route = {
    course: ROUTES.COURSES.FAQ,
    workshop: ROUTES.WORKSHOPS.FAQ,
    website: ROUTES.WEBSITE.FAQ,
  }[pathname] || ROUTES.WEBSITE.FAQ;

  const initialValues = {
    question: "",
    answer: "",
    type: pathname,
  };

  const validationSchema = Yup.object({
    question: Yup.string().required("Question is required"),
    answer: Yup.string().required("Answer is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      if (faqId) {
        values.faqId = faqId;
      }
      let response;
      if (faqId) {
        response = await dispatch(editFaq(values));
      } else {
        response = await dispatch(addFaq(values));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        navigate(route);
        resetForm();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleFaq(faqId));
    } catch (error) { }
  }, [dispatch, faqId]);

  useEffect(() => {
    if (faqId) {
      getSingleRecord();
    }
  }, [faqId, getSingleRecord]);

  useEffect(() => {
    if (faqId && singleFaq) {
      setValues({
        question: singleFaq?.question ?? "",
        answer: singleFaq?.answer ?? "",
        type: singleFaq?.type ?? "",
      });
    }
  }, [faqId, singleFaq, setValues]);

  return (
    <div>
      <div className="bg-background py-4 sm:py-4">
        <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
          <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">
            {action} FAQ
          </p>
          <form className="mt-6" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              {/* <div>
                <label className="text-sm font-medium text-foreground">
                  Select Type
                </label>
                <select
                  name="type"
                  className="w-full px-4 py-2 border border-border rounded-xl capitalize"
                  value={values?.type}
                  onChange={handleChange}
                >
                  {FaqType.map((val, i) => (
                    <option key={i} value={val}>{val}</option>
                  ))}
                </select>
              </div> */}
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-foreground">
                  Question
                </label>
                <input
                  type="text"
                  name="question"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.question}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Question"
                />
                {touched.question && errors.question && (
                  <div className="text-red-500 text-sm">{errors.question}</div>
                )}
              </div>

              <div className="md:col-span-2">
                <label className="text-sm font-medium text-foreground">
                  Answer
                </label>
                <textarea
                  name="answer"
                  rows={5}
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.answer}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Answer"
                />
                {touched.answer && errors.answer && (
                  <div className="text-red-500 text-sm">{errors.answer}</div>
                )}
              </div>
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7"
              >
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FAQForm;
